(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snapcase-discovery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sc-discovery')){
customElements.define('sc-discovery',class extends HTMLElement{
connectedCallback(){if(this.loaded)return;this.loaded=true;this.recent();this.suggestions()}
async get(url){const r=await fetch(url,{signal:AbortSignal.timeout(8000)});if(!r.ok)throw new Error('Unavailable');return r.json()}
card(p){
const li=document.createElement('li'),a=document.createElement('a'),media=document.createElement('div'),h=document.createElement('h3'),price=document.createElement('p');
a.href=this.dataset.root+'products/'+encodeURIComponent(p.handle);media.className='sc-discovery__image';
const src=typeof p.featured_image==='string'?p.featured_image:p.featured_image?.url;
if(src){const url=new URL(src,location.origin);if(url.protocol==='https:'){url.searchParams.set('width','640');const img=document.createElement('img');img.src=url.href;img.alt=p.title;img.width=640;img.height=640;img.loading='lazy';media.append(img)}}
h.textContent=p.title;price.textContent=(p.price_varies?this.dataset.from+' ':'')+new Intl.NumberFormat(document.documentElement.lang||'en-IN',{style:'currency',currency:this.dataset.currency||'INR'}).format(p.price/100);
a.append(media,h,price);if(!p.available){const badge=document.createElement('span');badge.className='sc-discovery__badge';badge.textContent=this.dataset.sold;a.append(badge)}li.append(a);return li
}
async recent(){
const section=this.querySelector('[data-recent]');if(!section)return;
const key='snapcase_recent_products_v1',handle=this.dataset.handle;let history=[];
try{const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))history=[...new Set(saved.filter(x=>typeof x==='string'&&/^[a-z0-9-]+$/.test(x)))];localStorage.setItem(key,JSON.stringify([handle,...history.filter(x=>x!==handle)].slice(0,12)))}catch{}
const results=await Promise.allSettled(history.filter(x=>x!==handle).slice(0,8).map(x=>this.get(this.dataset.root+'products/'+encodeURIComponent(x)+'.js')));
if(!this.isConnected)return;
const products=results.filter(x=>x.status==='fulfilled'&&x.value.handle!==handle).map(x=>x.value).slice(0,4);
section.querySelector('ul').replaceChildren(...products.map(p=>this.card(p)));section.hidden=!products.length
}
async suggestions(){
const section=this.querySelector('[data-suggestions]');if(!section)return;section.hidden=!section.querySelector('li');
try{const url=new URL(this.dataset.recommendations+'.json',location.origin);url.searchParams.set('product_id',this.dataset.id);url.searchParams.set('limit','4');url.searchParams.set('intent','related');const result=await this.get(url);const products=(result.products||[]).filter(p=>p.handle!==this.dataset.handle).slice(0,4);if(products.length&&this.isConnected){section.querySelector('ul').replaceChildren(...products.map(p=>this.card(p)));section.hidden=false}}catch{}
}
})}

  } catch(e) { console.error(e); }
})();
})();
